var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c(
            "div",
            { staticClass: "single container-max page-content" },
            [
              _c(
                "div",
                { staticClass: "row position-relative" },
                [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6" },
                    [_vm._t("image-carousel")],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 mt-3 mt-md-0" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "h1",
                          {
                            staticClass: "h2 title mb-4",
                            attrs: { "data-testing": "item-name" }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("itemName")(_vm.currentVariation))
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isShortDescriptionActive &&
                        _vm.currentVariation.texts.shortDescription !== ""
                          ? _c("p", {
                              staticClass: "single-description",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.currentVariation.texts.shortDescription
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-5" }, [
                          _c(
                            "span",
                            { staticClass: "articlenumber small d-block" },
                            [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemNumber"
                                    )
                                  ) + " "
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentVariation.variation.number)
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.currentVariation.filter.hasManufacturer
                            ? _c(
                                "span",
                                { staticClass: "articlenumber small d-block" },
                                [
                                  _c("b", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemManufacturer"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .externalName
                                        )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.unit
                            ? _c(
                                "span",
                                {
                                  staticClass: "articlenumber small d-block",
                                  class: {
                                    "is-single-piece":
                                      _vm.currentVariation.unit &&
                                      _vm.currentVariation.unit.content === 1 &&
                                      _vm.currentVariation.unit
                                        .unitOfMeasurement === "C62"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemContent"
                                          )
                                        )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("numberFormat")(
                                          _vm.currentVariation.unit.content
                                        )
                                      ) + " "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.unit.names.name
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.variation.mayShowUnitPrice
                            ? _c(
                                "span",
                                { staticClass: "articlenumber small d-block" },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemUnitPrice"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "base-price-value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("specialOffer")(
                                            _vm.variationGraduatedPrice
                                              .basePrice,
                                            _vm.currentVariation.prices,
                                            "basePrice"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.item.manufacturer.logo
                            ? _c("img", {
                                staticClass:
                                  "img-fluid d-block mt-3 manufacturerlogo",
                                attrs: {
                                  src:
                                    _vm.currentVariation.item.manufacturer.logo,
                                  alt:
                                    _vm.currentVariation.item.manufacturer
                                      .externalName
                                }
                              })
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.attributes.length || Object.keys(_vm.units).length
                          ? _c(
                              "div",
                              { staticClass: "mb-3" },
                              [_c("variation-select")],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentVariation.variation.bundleType === "bundle"
                          ? _c("item-bundle", {
                              attrs: {
                                "bundle-type":
                                  _vm.currentVariation.variation.bundleType,
                                "bundle-components":
                                  _vm.currentVariation.bundleComponents
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("before-price"),
                        _vm._v(" "),
                        _vm.currentVariation.filter.isSalable &&
                        _vm.variationGroupedProperties.length
                          ? _c("div", [_c("order-property-list")], 1)
                          : _vm._e(),
                        _vm._v(" "),
                        _c("graduated-prices"),
                        _vm._v(" "),
                        _c("item-price", {
                          attrs: {
                            "show-cross-price": _vm.isRecommendedPriceActive
                          }
                        }),
                        _vm._v(" "),
                        _vm._t("after-price"),
                        _vm._v(" "),
                        _c("item-availability"),
                        _vm._v(" "),
                        _vm.biozidDanger
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "biozid-danger alert alert-danger mt-3"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate(
                                        "MGCRedesign::Biozid.warningSingle"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-3 singleadd" }, [
                          _c(
                            "div",
                            { staticClass: "w-100" },
                            [_vm._t("before-add-to-basket")],
                            2
                          ),
                          _vm._v(" "),
                          _vm.currentVariation.item.itemType === "set"
                            ? _c(
                                "div",
                                { staticClass: "alert alert-info w-100" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemSetInfo"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-sm-7 col-md-12 col-lg-8 my-3"
                                },
                                [
                                  _c("add-to-basket", {
                                    attrs: {
                                      "variation-id":
                                        _vm.currentVariation.variation.id,
                                      "is-salable":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-children":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter
                                          .hasActiveChildren,
                                      "interval-quantity":
                                        _vm.currentVariation.variation
                                          .intervalOrderQuantity || 1,
                                      "minimum-quantity":
                                        _vm.currentVariation.variation
                                          .minimumOrderQuantity,
                                      "maximum-quantity":
                                        !!_vm.currentVariation.variation
                                          .maximumOrderQuantity &&
                                        _vm.currentVariation.variation
                                          .maximumOrderQuantity > 0
                                          ? _vm.currentVariation.variation
                                              .maximumOrderQuantity
                                          : null,
                                      "order-properties": _vm.currentVariation.properties.filter(
                                        function(prop) {
                                          return prop.property.isOderProperty
                                        }
                                      ),
                                      "has-order-properties":
                                        _vm.currentVariation.hasOrderProperties,
                                      "has-required-order-property":
                                        _vm.currentVariation
                                          .hasRequiredOrderProperty,
                                      "use-large-scale": false,
                                      "show-quantity": true,
                                      "item-url": _vm._f("itemURL")(
                                        _vm.currentVariation
                                      ),
                                      "is-variation-selected":
                                        _vm.isVariationSelected &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-price": _vm._f(
                                        "hasItemDefaultPrice"
                                      )(_vm.currentVariation)
                                    }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          !_vm.biozidDanger
                            ? _c(
                                "div",
                                { staticClass: "w-100 ppbutton" },
                                [_vm._t("after-add-to-basket")],
                                2
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.isWishListEnabled
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-12 wishlist mb-5" },
                                [
                                  _c("add-to-wish-list", {
                                    attrs: {
                                      "variation-id":
                                        _vm.currentVariation.variation.id
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("additional-content-after-add-to-basket"),
                        _vm._v(" "),
                        _vm._t("additional-content-after-vat"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "download-wrapper d-flex" },
                          [
                            _vm._l(
                              _vm.currentVariation.variationProperties,
                              function(property) {
                                return _vm.currentVariation.variationProperties
                                  ? [
                                      _vm._l(property.properties, function(
                                        property,
                                        index
                                      ) {
                                        return property.id == 16 ||
                                          property.id == 25
                                          ? [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "d-block mr-3 mt-3",
                                                  attrs: {
                                                    href: _vm._f(
                                                      "propertyFileUrl"
                                                    )(property.values.value),
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "img-fluid d-block mx-auto mb-2",
                                                    attrs: {
                                                      src:
                                                        "https://cdn02.plentymarkets.com/gw81lpaq889b/frontend/webshop/images/static/icons/2021/pdficon.svg",
                                                      alt: property.names.name
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "color-dark small font-weight-bold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          property.names.name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      })
                                    ]
                                  : _vm._e()
                              }
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "properties-wrapper d-flex" },
                          [
                            _vm._l(
                              _vm.currentVariation.variationProperties,
                              function(property) {
                                return _vm.currentVariation.variationProperties
                                  ? [
                                      _vm._l(property.properties, function(
                                        property,
                                        index
                                      ) {
                                        return property.id == 26
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-block mr-3 mt-3"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "color-dark small font-weight-bold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          property.values.value
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("img", {
                                                    staticClass:
                                                      "img-fluid d-block mx-auto mb-2",
                                                    attrs: {
                                                      src: property.description,
                                                      alt: property.values.value
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      })
                                    ]
                                  : _vm._e()
                              }
                            )
                          ],
                          2
                        )
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "my-5" }, [
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-tabs",
                          attrs: { role: "tablist" }
                        },
                        [
                          _vm.isDescriptionTabActive
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link active",
                                    attrs: {
                                      "data-toggle": "tab",
                                      href:
                                        "#details-" +
                                        _vm.currentVariation.variation.id,
                                      role: "tab"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemDescription"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isTechnicalDataTabActive
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    class: {
                                      active:
                                        !_vm.isDescriptionTabActive &&
                                        _vm.isTechnicalDataTabActive
                                    },
                                    attrs: {
                                      "data-toggle": "tab",
                                      href:
                                        "#data-" +
                                        _vm.currentVariation.variation.id,
                                      role: "tab"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemTechnicalData"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEuResponsibleTabShown
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    attrs: {
                                      "data-toggle": "tab",
                                      href: "#eu-responsible",
                                      role: "tab"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemEuResponsiblePerson"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("add-detail-tabs")
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tab-content overflow-hidden" },
                        [
                          _vm.isDescriptionTabActive
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-pane active overflow-auto",
                                  attrs: {
                                    id:
                                      "details-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tabpanel"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "my-4",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentVariation.texts.description
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isTechnicalDataTabActive
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-pane overflow-auto",
                                  class: {
                                    active:
                                      !_vm.isDescriptionTabActive &&
                                      _vm.isTechnicalDataTabActive
                                  },
                                  attrs: {
                                    id:
                                      "data-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tabpanel"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "my-4",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentVariation.texts.technicalData
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEuResponsibleTabShown
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-pane overflow-auto",
                                  attrs: {
                                    id: "eu-responsible",
                                    role: "tabpanel"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "my-4" }, [
                                    _vm.currentVariation.filter.hasManufacturer
                                      ? _c(
                                          "div",
                                          { staticClass: "manufacturer mb-3" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "font-weight-bold mb-0"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "MGCRedesign::Single.ManufacturerHeadline"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.currentVariation.item
                                              .manufacturer.name
                                              ? _c(
                                                  "div",
                                                  { staticClass: "p-0" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currentVariation
                                                            .item.manufacturer
                                                            .name
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.currentVariation.item
                                              .manufacturer.street
                                              ? _c(
                                                  "div",
                                                  { staticClass: "p-0" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currentVariation
                                                            .item.manufacturer
                                                            .street
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.currentVariation
                                                              .item.manufacturer
                                                              .houseNo
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.currentVariation.item
                                              .manufacturer.postcode
                                              ? _c(
                                                  "div",
                                                  { staticClass: "p-0" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currentVariation
                                                            .item.manufacturer
                                                            .postcode
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.currentVariation
                                                              .item.manufacturer
                                                              .town
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.currentVariation.item
                                              .manufacturer.countryObject
                                              ? _c(
                                                  "div",
                                                  { staticClass: "p-0" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currentVariation
                                                            .item.manufacturer
                                                            .countryObject.name
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.currentVariation.item
                                              .manufacturer.url
                                              ? _c(
                                                  "div",
                                                  { staticClass: "p-0" },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            _vm.currentVariation
                                                              .item.manufacturer
                                                              .url,
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentVariation
                                                              .item.manufacturer
                                                              .url
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "font-weight-bold mb-0" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "MGCRedesign::Single.EUHeadline"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-0" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsibleName
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-0" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsibleStreet
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.currentVariation.item
                                                .manufacturer.responsibleHouseNo
                                            )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-0" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.currentVariation.item
                                              .manufacturer.responsiblePostCode
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.currentVariation.item
                                                .manufacturer.responsibleTown
                                            )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-0" }, [
                                      _vm.currentVariation.item.manufacturer
                                        .responsibleCountryObject
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.currentVariation.item
                                                    .manufacturer
                                                    .responsibleCountryObject
                                                    .name
                                                ) +
                                                "\n                    "
                                            )
                                          ])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-0" }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "mailto:" +
                                              _vm.currentVariation.item
                                                .manufacturer.responsibleEmail
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer.responsibleEmail
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-0" }, [
                                      _c("span", [_vm._v("Tel: ")]),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "tel:" +
                                              _vm.currentVariation.item
                                                .manufacturer.responsiblePhoneNo
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.item
                                                .manufacturer.responsiblePhoneNo
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("add-detail-tabs-content")
                        ],
                        2
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.currentVariation.item.manufacturer.id == 604 ||
                  _vm.currentVariation.item.manufacturer.id == 6 ||
                  _vm.currentVariation.item.manufacturer.id == 4127
                    ? [
                        _c(
                          "div",
                          { staticClass: "col-12 bee my-5" },
                          [
                            _c("div", {
                              staticClass: "loadbeeTabContent",
                              attrs: {
                                "data-loadbee-apikey":
                                  "C75UvVXJx5gG39mdbFWmarvwXEVxww4X",
                                "data-loadbee-gtin":
                                  _vm.currentVariation.barcodes[0].code,
                                "data-loadbee-locale": "de_DE"
                              }
                            }),
                            _vm._v(" "),
                            _c("script2", {
                              attrs: {
                                async: "",
                                src:
                                  "https://cdn.loadbee.com/js/loadbee_integration.js"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-5" },
                [_vm._t("item-list-container")],
                2
              ),
              _vm._v(" "),
              _vm._t("feedback-container")
            ],
            2
          )
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }